import React, { useReducer } from "react";
import { Modal, Popup, Icon } from "semantic-ui-react";
import PaymentActAllActs from "../../ActPatient/Steps/PaymentActAllActs";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <>
      <Popup
        content="Historique Paiement"
        trigger={
          <Icon
            circular
            inverted
            color="black"
            floated="left"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
            name="dollar sign"
            size="large"
            className="centerIcon_And_Float_RightMod"
          />
        }
      />
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header className="center3columnheaders">Paiement</Modal.Header>
        <Modal.Content>
          <PaymentActAllActs />
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Note;
